import { JsonPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, TemplateRef } from '@angular/core';
import { StateIndicator, StateIndicatorKeys } from './state-indicator.model';

@Component({
  selector: 'ui-state-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet],
  template: `
    @if (currentState()?.content) {
      <ng-container *ngTemplateOutlet="currentState()?.content || null; context: {$implicit: indicator()}"></ng-container>
    } @else {
      <div class="w-3 h-3 rounded-full transition-all duration-300" [class]="currentState()?.class">
        <ng-content></ng-content>
      </div>
    }
  `,
})
export class StateIndicatorComponent {
  /**
   * Indicator.
   */
  indicator = input<any>();

  /**
   * State of the indicator.
   */
  state = input<StateIndicatorKeys>();

  /**
   * States of the indicator.
   */
  states = input<StateIndicator | null>();

  /**
   * Map the state to corresponding states.
   */
  currentState = computed(() => this.states()?.[this.state() || '']);
}
